/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PARTICIPANT_STATUS } from '../../../../constants/consentStatus';
import { NOT_PARTICIPATING } from '../../../../const';

const detailsConfig = {
  total: 'Total number of participants',
  values: PARTICIPANT_STATUS
};

const StudyDetails = ({ overallStatus }) => {
  const {
    total,
    CONSENTED,
    WAITING_CONSENT,
    WAITING_RECONSENT,
    STUDY_COMPLETED,
    STUDY_TERMINATED,
    ABORTED,
    WITHDRAWN_CONSENT,
    FAILED_SCREENING
  } = overallStatus;

  return (
    <div className="overall-details-list">
      <ul>
        <li className="total">
          <div className="tc-overall-value">{total}</div>
          <div className="tc-overall-title">{detailsConfig.total}</div>
        </li>
        <li className="consented">
          <div className="tc-overall-value">{CONSENTED}</div>
          <div className="tc-overall-title">{detailsConfig.values.CONSENTED}</div>
        </li>
        <li className="waiting-consent">
          <div className="tc-overall-value">{WAITING_CONSENT}</div>
          <div className="tc-overall-title">{detailsConfig.values.WAITING_CONSENT}</div>
        </li>
        <li className="waiting-reconsent">
          <div className="tc-overall-value">{WAITING_RECONSENT}</div>
          <div className="tc-overall-title">{detailsConfig.values.WAITING_RECONSENT}</div>
        </li>
        <li className="not-participating">
          <div className="tc-overall-value">{STUDY_TERMINATED + ABORTED + WITHDRAWN_CONSENT + FAILED_SCREENING}</div>
          <div className="tc-overall-title">{NOT_PARTICIPATING}</div>
        </li>
        <li className="completed">
          <div className="tc-overall-value">{STUDY_COMPLETED}</div>
          <div className="tc-overall-title">{detailsConfig.values.STUDY_COMPLETED}</div>
        </li>
      </ul>
    </div>
  );
};

StudyDetails.propTypes = {
  overallStatus: PropTypes.object
};

export default StudyDetails;
